import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from '../../pages/ProductSelection.module.css';
import useProductSelectionStore from '../../stores/useProductSelectionStore';
import { ReactComponent as CartIcon } from '../../images/icons/ProductSelectionPage/carticon.svg';
import { ReactComponent as HomeIcon } from '../../images/icons/ProductSelectionPage/homeicon.svg';
import { ReactComponent as PrintsIcon } from '../../images/icons/ProductSelectionPage/printsicon.svg';
import { ReactComponent as AlbumsIcon } from '../../images/icons/ProductSelectionPage/albumsicon.svg';
import { ReactComponent as FramedPrintsIcon } from '../../images/icons/ProductSelectionPage/framedprintsicon.svg';
import { ReactComponent as MultiOpeningIcon } from '../../images/icons/ProductSelectionPage/multiopeningicon.svg';
import { ReactComponent as CircleOvalIcon } from '../../images/icons/ProductSelectionPage/circleovalicon.svg';
import { ReactComponent as MattedPrintsIcon } from '../../images/icons/ProductSelectionPage/mattedprintsicon.svg';
import { ReactComponent as MountedPrintsIcon } from '../../images/icons/ProductSelectionPage/mountedprintsicon.svg';
import { ReactComponent as CanvasIcon } from '../../images/icons/ProductSelectionPage/canvasicon.svg';
import { ReactComponent as ArtistProofsIcon } from '../../images/icons/ProductSelectionPage/artistproofsicon.svg';
import { ReactComponent as TestPrintsIcon } from '../../images/icons/ProductSelectionPage/testprintsicon.svg';
import { PRODUCT_TYPE_OPTIONS } from '../../lib/const';

const ICON_MAP = {
  prints: PrintsIcon,
  albums: AlbumsIcon,
  'framed-prints': FramedPrintsIcon,
  'multi-opening': MultiOpeningIcon,
  'circle-oval': CircleOvalIcon,
  'matted-prints': MattedPrintsIcon,
  'mounted-prints': MountedPrintsIcon,
  canvas: CanvasIcon,
  'test-prints': TestPrintsIcon,
  'artist-proofs': ArtistProofsIcon,
};

const ProductTypeSelector = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { setProductType, cartCount } = useProductSelectionStore();
  const [hoveredId, setHoveredId] = useState(null);

  const handleSelect = (productId) => {
    console.log("Product Id", productId);
    setProductType(productId);
  };

  const handleHomeClick = () => {
    setProductType('default');
    navigate('/');
  };

  const handleCartClick = () => {
    if (id) {
      navigate(`/lab-orders/${id}/summary`);
    }
  };

  return (
    <div className={styles.productSelectionPage}>
      {/*Nav Bar*/}
      <nav className={styles.productSelectionNav}>
        <button
          className={styles.navIconButton}
          onClick={handleHomeClick}
          aria-label="Go home"
          type="button"
        >
          <HomeIcon />
        </button>

        <button
          className={`${styles.navIconButton} ${styles.cartButton}`}
          onClick={handleCartClick}
          aria-label={`Cart, ${cartCount} item${cartCount !== 1 ? 's' : ''}`}
          type="button"
        >
          <CartIcon />
          <span className={styles.cartBadge} aria-hidden="true">
            {cartCount}
          </span>
        </button>
      </nav>

      {/*Page Header*/}
      <div className={styles.productSelectionHeader}>
        <h1 className={styles.productSelectionTitle}>Choose a product type</h1>
        <p className={styles.productSelectionSubtitle}>
          Pick a category to start uploading photos for this order.
        </p>
      </div>

      {/*Product Grid*/}
      <div className={styles.productTypeGrid}>
        {PRODUCT_TYPE_OPTIONS.map(({ value, text }) => {
          const Icon = ICON_MAP[value];
          return (
            <button
              key={value}
              className={`${styles.productTypeCard} ${hoveredId === value ? styles.productTypeCardHovered : ''}`}
              onClick={() => handleSelect(value)}
              onMouseEnter={() => setHoveredId(value)}
              onMouseLeave={() => setHoveredId(null)}
              type="button"
              aria-label={`Select ${text}`}
            >
              <div className={styles.productTypeIconArea}>
                {Icon && <Icon />}
              </div>
              <span className={styles.productTypeLabel}>{text}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProductTypeSelector;
